import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from '../../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';

function RouteSelectGrowth({ filterdata, onChange }) {
  const { sendReq: fetchData } = useHttp();
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRoutes, setSelectedRoutes] = useState([]);

  useEffect(() => {
    if (!filterdata.DEPO?.length) {
      setRouteOptions([]);
      setSelectedRoutes([]);
      return;
    }

    const url = `${API_URL_MAIN}growth_tracking/route`;
    fetchData(
      {
        url,
        body: { IND: "ROUTE_INDEX", filterdata },
      },
      (data) => {
        const buckets = data?.unique_depo?.buckets || [];
        const options = buckets.map((item) => ({
          id: item.key.route,
          value: item.key.route,
          label: item.key.route.toString(),
        }));

        const finalOptions = options.length
          ? [{ label: "All", value: "*" }, ...options]
          : [];

        setRouteOptions(finalOptions);
        setSelectedRoutes(finalOptions);
        if (onChange) onChange([]);
      }
    );
  }, [filterdata.DEPO]);

  const handleChange = (value, event) => {
    if (event.option?.value === "*") {
      if (event.action === "select-option") {
        setSelectedRoutes(routeOptions);
        onChange([]);
      } else {
        setSelectedRoutes([]);
        onChange([]);
      }
    } else {
      const filtered = value.filter((v) => v.value !== "*");
      setSelectedRoutes(filtered);
      onChange(
        filtered.length === routeOptions.length - 1
          ? []
          : filtered.map((v) => v.value)
      );
    }
  };

  const getDropdownLabel = ({ placeholderButtonLabel, value }) => {
    if (Array.isArray(value)) {
      const routeOpts = routeOptions.filter((o) => o.value !== "*");
      if (!value.length) return "Select...";
      if (value.some((v) => v.value === "*") || value.length === routeOpts.length) return "All";
      return `${value.length} selected`;
    }
    return placeholderButtonLabel;
  };

  return (
    <ReactMultiSelectCheckboxes
      className="react-select-container"
      classNamePrefix="react-select"
      options={routeOptions}
      value={selectedRoutes}
      onChange={handleChange}
      getDropdownButtonLabel={getDropdownLabel}
      placeholderButtonLabel="Select Route"
      isMulti
    />
  );
}

export default RouteSelectGrowth;
